import { Pipe, PipeTransform } from '@angular/core';
import { ActivityInterface } from '@vendasta/crm';
import { ObjectAssociationType, ObjectType, ObjectTypes } from '../../../tokens-and-interfaces';

type Type = ObjectType | ObjectAssociationType;
interface Input {
  objectType: Type;
  crmObjectId: string;
}
interface Output {
  objectType: ObjectType;
  crmObjectId: string;
}

@Pipe({
  name: 'crmTimelineAssociatedObject',
  standalone: true,
})
export class CrmTimelineAssociatedObjectPipe implements PipeTransform {
  transform(activity: ActivityInterface, crmObject?: Input): Output {
    if (crmObject && this.isObjectType(crmObject.objectType)) {
      return {
        objectType: crmObject.objectType,
        crmObjectId: crmObject.crmObjectId,
      };
    }

    // Get the first associated Company or Contact
    if (activity?.associations?.length) {
      for (const asc of activity.associations) {
        if (this.isObjectType(asc.crmObjectType)) {
          return {
            objectType: asc.crmObjectType as ObjectType,
            crmObjectId: asc.crmObjectId as string,
          };
        }
      }
    }

    return {} as Output;
  }

  private isObjectType(objectType?: string): objectType is ObjectType {
    return ObjectTypes.includes(objectType as ObjectType);
  }
}
